import type { To } from "react-router-dom";
import {
  ADMIN_DASHBOARD_LOCALE_QUERY_PARAM,
  type AdminDashboardLocale,
} from "./admin-dashboard-locale";

function normalizeSearch(search: string | undefined): string {
  if (!search || search.length === 0) {
    return "";
  }

  return search.startsWith("?") ? search : `?${search}`;
}

export function withAdminDashboardLocaleSearchParams(
  params: URLSearchParams,
  locale: AdminDashboardLocale,
): URLSearchParams {
  const next = new URLSearchParams(params);
  next.set(ADMIN_DASHBOARD_LOCALE_QUERY_PARAM, locale);
  return next;
}

export function withAdminDashboardLocaleTo(
  to: To,
  locale: AdminDashboardLocale,
): To {
  if (typeof to === "string") {
    const url = new URL(to, "https://petlog.local");
    url.searchParams.set(ADMIN_DASHBOARD_LOCALE_QUERY_PARAM, locale);
    return `${url.pathname}${url.search}${url.hash}`;
  }

  const nextSearch = withAdminDashboardLocaleSearchParams(
    new URLSearchParams(normalizeSearch(to.search)),
    locale,
  ).toString();

  return {
    ...to,
    search: nextSearch.length > 0 ? `?${nextSearch}` : "",
  };
}
